"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var environment_1 = require("../environments/environment");
var searchv2_service_1 = require("./services/searchv2.service");
var labels_1 = require("@project/shared/utils/labels/js/labels");
require("rxjs/add/operator/map");
var Searchv2Component = /** @class */ (function () {
    /**
     * @param searchAppService
     * @param route
     * @param router
     */
    function Searchv2Component(searchAppService, route, router) {
        this.searchAppService = searchAppService;
        this.route = route;
        this.router = router;
        this.environment = environment_1.environment;
        this._shouldFocus = true;
        this._showLoadMoreSpinner = false;
        this._overAllcount = 0;
        this._displayResults = false;
        this._lastHref = '';
        this._searchResultTabs = [];
    }
    /**
     * Implementation of Angular OnInit lifecycle hook.
     * Transform JSON configuartion to object and bind it to ProductFinderv2Component
     */
    Searchv2Component.prototype.ngOnInit = function () {
        var _this = this;
        // validate json configs
        this.validateAndSetConfigurationItems();
        this.resolveUrlParams();
        window.onbeforeunload = function () {
            _this.cacheTabResults();
        };
    };
    Searchv2Component.prototype.search = function (searchText, replaceHistory) {
        if (replaceHistory === void 0) { replaceHistory = false; }
        var activeTab = this.lastClickedTab;
        var lastQuery = this._lastUrlParams ? this._lastUrlParams.query : undefined;
        if (searchText === lastQuery && this._lastUrlParams.pageSize == undefined) {
            this._getDataForNewResults(this._lastUrlParams);
        }
        else {
            this.router.navigate(['.'], {
                queryParams: {
                    query: searchText,
                    tab: activeTab ? activeTab.tab.types.join(',') : undefined,
                },
                replaceUrl: replaceHistory,
                relativeTo: this.route,
            });
        }
    };
    Searchv2Component.prototype.resolveUrlParams = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            if (Object.keys(params).length > 0 && params.constructor === Object) {
                if (params.query) {
                    var lastQuery = _this._lastUrlParams ? _this._lastUrlParams.query : undefined;
                    if (params.query !== lastQuery || params.pageSize == undefined) {
                        _this._getDataForNewResults(params);
                    }
                    else {
                        var lastPageSize = 0;
                        if (params.tab) {
                            var currentTab = _this._searchResultTabs.filter(function (t) { return t.tab.types.join(',') === params.tab; })[0];
                            _this.lastClickedTab = currentTab;
                            lastPageSize = currentTab.currentCount || undefined;
                        }
                        if (parseInt(params.pageSize, 10) !== lastPageSize) {
                            _this._getDataForMoreResults();
                        }
                    }
                }
                else {
                    _this.displayResults = false;
                    _this._overAllcount = 0;
                }
                _this._lastHref = window.location.href;
            }
            else {
                _this.displayResults = false;
                _this._overAllcount = 0;
                _this.searchText = '';
            }
            _this._lastUrlParams = params;
        });
    };
    Searchv2Component.prototype.tabChange = function (activeTab) {
        this.lastClickedTab = activeTab;
        this.router.navigate(['.'], {
            queryParams: { tab: activeTab.tab.types.join(','), pageSize: activeTab.currentCount },
            queryParamsHandling: 'merge',
            replaceUrl: true,
            relativeTo: this.route,
        });
    };
    Searchv2Component.prototype.loadNewResult = function (params) {
        var _this = this;
        var tabActivated = false;
        var biggestTab = this._searchResultTabs[0];
        var biggestResultNumber = 0;
        var loadedTabs = 0;
        var initialPageSize = params.pageSize
            ? parseInt(params.pageSize, 10)
            : this.config.pagination.pageSizeInitial;
        this._searchResultTabs.forEach(function (t, index) {
            t.currentCount = 0;
            t.loading = true;
            _this._overAllcount = 0;
            if (params.tab && params.tab === t.tab.types.join(',')) {
                _this.lastClickedTab = t;
                t.active = true;
                tabActivated = true;
            }
            else {
                t.active = false;
            }
            _this.searchAppService
                .getSearchResult(_this.searchText, t.tab, t.currentCount, initialPageSize)
                .subscribe(function (data) {
                loadedTabs += 1;
                if (!data || data.error) {
                    t.error = true;
                    t.loading = false;
                }
                else if (data) {
                    t.error = false;
                    t.loading = false;
                    t.results = data.results;
                    t.totalCount = data.totalCount;
                    t.currentCount = data.results.length;
                    if (t.totalCount > biggestResultNumber) {
                        biggestResultNumber = t.totalCount;
                        biggestTab = t;
                    }
                    if (!t.tab.disableCounter) {
                        _this._overAllcount += data.totalCount;
                    }
                }
                // if no tab is hard selected through url param, show first tab with most results in the response
                if (loadedTabs >= _this._searchResultTabs.length && !tabActivated) {
                    biggestTab.active = true;
                    _this.router.navigate(['.'], {
                        queryParams: { tab: biggestTab.tab.types.join(','), pageSize: biggestTab.currentCount },
                        queryParamsHandling: 'merge',
                        replaceUrl: true,
                        relativeTo: _this.route,
                    });
                }
            });
        });
    };
    Searchv2Component.prototype._getDataForNewResults = function (params) {
        var _this = this;
        this.cacheTabResults();
        this._searchText = params.query;
        var cachedTabs;
        cachedTabs = JSON.parse(sessionStorage.getItem(window.location.href));
        if (cachedTabs) {
            this._shouldFocus = false;
            this._searchResultTabs = cachedTabs;
            this._overAllcount = 0;
            this._searchResultTabs.forEach(function (tab) {
                _this._overAllcount += tab.totalCount;
            });
        }
        else {
            this.loadNewResult(params);
        }
        this.loadProductScroller(params);
        this.displayResults = true;
    };
    Searchv2Component.prototype._getDataForMoreResults = function () {
        var _this = this;
        this._searchResultTabs.filter(function (t) { return t.active; }).forEach(function (t) {
            _this.showLoadMoreSpinner = true;
            _this.searchAppService
                .getSearchResult(_this.searchText, t.tab, t.currentCount, _this.config.pagination.pageSizeLoadMore)
                .subscribe(function (data) {
                _this.showLoadMoreSpinner = false;
                if (data) {
                    data.results.forEach(function (r) { return t.results.push(r); });
                    t.currentCount += data.results.length;
                    _this.router.navigate(['.'], {
                        queryParams: { pageSize: t.currentCount },
                        queryParamsHandling: 'merge',
                        replaceUrl: true,
                        relativeTo: _this.route,
                    });
                }
            });
        });
    };
    Searchv2Component.prototype.loadProductScroller = function (params) {
        var _this = this;
        var currentCount = 0;
        this._productScroller.loading = true;
        var initialPageSize = params.pageSize
            ? parseInt(params.pageSize, 10)
            : this.config.pagination.pageSizeInitial;
        this.searchAppService
            .getProductScrollerSearchResult(this.searchText, currentCount, initialPageSize)
            .subscribe(function (data) {
            if (!data || data.error) {
                //t.error = true;
                _this._productScroller.loading = false;
            }
            else if (data) {
                _this._productScroller.loading = false;
                _this._productScroller.results = data.results;
                _this._productScroller.totalCount = data.totalCount;
            }
        });
    };
    Searchv2Component.prototype.cacheTabResults = function () {
        if (this._searchResultTabs.length > 0 && this._lastHref && !this.hasErrors()) {
            this.clearCacheOverLimit();
            sessionStorage.setItem(this._lastHref, JSON.stringify(this._searchResultTabs));
        }
    };
    Searchv2Component.prototype.clearCacheOverLimit = function () {
        var maxCachedSites = 30;
        var cachedSitesSessionStorageKey = 'CovestroSearchComponentCachedSites';
        var cachedSites = JSON.parse(sessionStorage.getItem(cachedSitesSessionStorageKey)) || [];
        if (cachedSites.length >= maxCachedSites) {
            var numberOfSitesToRemove = cachedSites.length - maxCachedSites + 1;
            for (var i = 0; i < numberOfSitesToRemove; i++) {
                sessionStorage.removeItem(cachedSites[i]);
            }
            cachedSites.splice(0, numberOfSitesToRemove);
        }
        cachedSites.push(this._lastHref);
        sessionStorage.setItem(cachedSitesSessionStorageKey, JSON.stringify(cachedSites));
    };
    Searchv2Component.prototype.loadMoreResults = function () {
        var _this = this;
        var newCount = 0;
        this._searchResultTabs.filter(function (t) { return t.active; }).forEach(function (t) {
            newCount = t.currentCount + _this.config.pagination.pageSizeLoadMore;
        });
        this.router.navigate(['.'], {
            queryParams: { pageSize: newCount },
            queryParamsHandling: 'merge',
            replaceUrl: true,
            relativeTo: this.route,
        });
    };
    Searchv2Component.prototype.isLoading = function () {
        return this.searchResultTabs.some(function (t) { return t.loading; }) || this._productScroller.loading;
    };
    Searchv2Component.prototype.hasContentResults = function () {
        return this._overAllcount > 0;
    };
    Searchv2Component.prototype.hasProductResults = function () {
        return this._productScroller.totalCount > 0;
    };
    Searchv2Component.prototype.hasErrors = function () {
        return this.searchResultTabs.some(function (t) { return t.error; });
    };
    Searchv2Component.prototype.showLoadMoreButton = function () {
        var activeTab = this._searchResultTabs.find(function (t) { return t.active; });
        return activeTab && activeTab.currentCount < activeTab.totalCount;
    };
    /**
     * Validates the JSON config string set by SiteCore and set config from config property
     */
    Searchv2Component.prototype.validateAndSetConfigurationItems = function () {
        var _this = this;
        this.searchAppService.getConfig().subscribe(function (config) {
            if (!config) {
                return;
            }
            _this.config = config;
            if (_this.config.search.placeholder) {
                _this.searchText = _this.config.search.placeholder;
            }
            // set all headings
            _this.setTabs();
            if (_this.config.productScroller) {
                _this._productScroller = _this.config.productScroller;
            }
        });
    };
    /**
     * Gets Headline information from the config and updates headline properties bound to ProductTableComponent, which are:
     * - heading
     * - columnHeading
     */
    Searchv2Component.prototype.setTabs = function () {
        var _this = this;
        if (this.config.tabs) {
            this.config.tabs.map(function (t) { return _this.searchResultTabs.push({ tab: t }); });
        }
    };
    Object.defineProperty(Searchv2Component.prototype, "noResultsTitle", {
        get: function () {
            return labels_1.formatLabel(this.config.search.noResultsTitle, this.searchText || '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "noResultsText", {
        get: function () {
            return this.config.search.noResultsText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "loadMoreText", {
        get: function () {
            return this.config.loadMoreButton.text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "loadMoreModifer", {
        get: function () {
            return this.config.loadMoreButton.modifier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "resultHeadingLevel", {
        get: function () {
            return this.config.resultsHeading.level;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "resultHeadingModifier", {
        get: function () {
            return this.config.resultsHeading.modifier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "resultHeadingClass", {
        get: function () {
            return this.config.resultsHeading.class;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "resultHeadingText", {
        get: function () {
            return labels_1.formatLabel(this.config.resultsHeading.text, this._overAllcount, this.searchText);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "productResultHeadingLevel", {
        get: function () {
            return this.config.productResultsHeading.level;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "productResultHeadingModifier", {
        get: function () {
            return this.config.productResultsHeading.modifier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "productResultHeadingClass", {
        get: function () {
            return this.config.productResultsHeading.class;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "productResultHeadingText", {
        get: function () {
            return labels_1.formatLabel(this.config.productResultsHeading.text, this.searchText);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "searchText", {
        get: function () {
            return this._searchText;
        },
        set: function (value) {
            this._searchText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "shouldFocus", {
        get: function () {
            return this._shouldFocus;
        },
        set: function (value) {
            this._shouldFocus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "searchResultTabs", {
        get: function () {
            return this._searchResultTabs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "showLoadMoreSpinner", {
        get: function () {
            return this._showLoadMoreSpinner;
        },
        set: function (value) {
            this._showLoadMoreSpinner = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "errorMessage", {
        get: function () {
            return this.config.search.errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "displayResults", {
        get: function () {
            return this._displayResults;
        },
        set: function (value) {
            this._displayResults = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "searchTeaserBottomProductFinder", {
        get: function () {
            return this._searchTeaserBottomProductFinder;
        },
        set: function (value) {
            this._searchTeaserBottomProductFinder = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "searchTeaserTopProductFinder", {
        /**
         * Returns the model for the search teaser "product finder"
         */
        get: function () {
            return this._searchTeaserTopProductFinder;
        },
        /**
         * Sets the model for the search teaser "product finder"
         */
        set: function (value) {
            this._searchTeaserTopProductFinder = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "productResultSortOrder", {
        /**
         * Returns the sort order for product results.
         */
        get: function () {
            return this.config.productFinderSearch.relevanceSortCode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "productScroller", {
        get: function () {
            return this._productScroller;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "productScrollerLoading", {
        get: function () {
            return this._productScroller.loading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "noResultTeaserBanners", {
        get: function () {
            return this.config.noResultTeaserBanners;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchv2Component.prototype, "bottomResultsHeading", {
        get: function () {
            var activeTab = this._searchResultTabs.find(function (t) { return t.active; });
            return labels_1.formatLabel(this.config.bottomResultsHeading, activeTab.currentCount, activeTab.totalCount);
        },
        enumerable: true,
        configurable: true
    });
    return Searchv2Component;
}());
exports.Searchv2Component = Searchv2Component;
